/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export const SET_MENU_LANGUAGE_VERTICAL_POSITION = 'SET_SETTINGS_MENU_VERTICAL_POSITION';
export const SET_MENU_LANGUAGE_IS_ACTIVE = 'SET_MENU_LANGUAGE_IS_ACTIVE';
export const SET_DEFAULT_MENU_LANGUAGE_STATE = 'SET_DEFAULT_MENU_LANGUAGE_STATE';
